import React from "react";
import "./DoctorJourneyStyle.css";
import { useTranslation } from "react-i18next";

const DoctorJourney = ({ id }) => {
  const { t, i18n } = useTranslation();

  const journeySteps = [
    {
      title: "diagnosis",
      description:
        "We analyze your current content like we would a patient scan, looking for silent gaps.",
    },
    {
      title: "strategy",
      description:
        "One size fits all doesn’t work in medicine or marketing. We craft customized plans to suit your specialty.",
    },
    {
      title: "creative",
      description:
        "3D visuals, branded storytelling, case study reels, and social media marketing built to turn heads and build trust.",
    },
    {
      title: "monitoring",
      description:
        "We don't vanish after the first campaign. We test, measure, and adapt monthly based on real-time results.",
    },
  ];

  return (
    <section className={`doctor-journey-container ${i18n.dir()}`} id={id}>
      <h2 className="journey-title">{t("doctorJourney.title")}</h2>
      <ol className="journey-timeline">
        {journeySteps.map((step, index) => (
          <div
            key={index}
            className={`journey-step ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="step-circle"></div>
            <div className="step-content">
              <h3 className="step-title">
                {t(`doctorJourney.steps.${step.title}.title`)}
              </h3>
              <p className="step-description">
                {t(`doctorJourney.steps.${step.title}.description`)}
              </p>
            </div>
          </div>
        ))}
      </ol>
    </section>
  );
};

export default DoctorJourney;
